import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { adminLogin, getStoredAdminCredentials } from '../../lib/adminApi';
import './AdminLogin.css';

const AdminLogin = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (getStoredAdminCredentials()) {
            navigate('/admin/dashboard');
        }
    }, [navigate]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        try {
            const success = await adminLogin({ adminUsername: username, adminPassword: password });
            if (success) {
                navigate('/admin/dashboard');
            } else {
                setError('Invalid admin credentials.');
            }
        } catch {
            setError('Could not reach the server.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-login">
            <h2>Admin Panel</h2>
            <p className="admin-subtitle">Authorized Personnel Only</p>

            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Admin Username"
                    autoComplete="username"
                />
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Admin Password"
                    autoComplete="current-password"
                />
                <button type="submit" disabled={loading || !username || !password}>
                    {loading ? 'Authenticating...' : 'Sign In'}
                </button>
            </form>

            {error && <p className="error">{error}</p>}

            <Link to="/" className="back-link">
                &larr; Back to Trader Login
            </Link>
        </div>
    );
};

export default AdminLogin;
